import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MarketingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Marketing",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M11.29 28.15c-2.52 0-4.57-2.05-4.57-4.57v-2.29a1.14 1.14 0 1 1 2.28 0v2.29c0 1.26 1.03 2.29 2.29 2.29s2.29-1.03 2.29-2.29v-2.29a1.14 1.14 0 1 1 2.28 0v2.29c0 2.52-2.05 4.57-4.57 4.57M28.31 12.67a1.145 1.145 0 0 1-.29-2.25l2.4-.64c.6-.16 1.24.2 1.4.81s-.2 1.24-.81 1.4l-2.4.64c-.1.03-.2.04-.3.04M24.9 7.98c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l1.84-1.84a1.15 1.15 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-1.84 1.84c-.22.22-.52.33-.81.33M30.21 19.11c-.1 0-.2-.01-.3-.04l-2.51-.67c-.61-.16-.97-.79-.81-1.4s.79-.97 1.4-.81l2.51.67a1.145 1.145 0 0 1-.29 2.25"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.12 22.44H2.4c-.52 0-.97-.35-1.1-.85l-1.4-5.21c-.13-.5.08-1.03.53-1.29L19.24 4.23c.31-.18.68-.2 1.01-.07.33.14.57.42.67.76L25.23 21c.09.34.02.71-.2.99s-.55.45-.91.45M3.28 20.15h19.36L19.1 6.95 2.33 16.63l.94 3.52Z"
    })]
  }));
};